<!-- Start Course Calendar Section -->
<section class="ecb-course-calendar-section">

    <div class="container-fluid ecb-course-calendar-container">

        <div class="ecb-course-calendar-page">


            <!-- ===================================================== -->
            <!-- PAGE HEADER -->
            <!-- ===================================================== -->

            <div class="ecb-course-calendar-page-header">

                <div class="ecb-course-calendar-page-title">

                    <div class="ecb-course-calendar-title-icon">
                        <i class="bi bi-calendar3"></i>
                    </div>

                    <div>

                        <h2>
                            Course Calendar
                        </h2>

                        <p>
                            View and book upcoming training courses
                        </p>

                    </div>

                </div>


                <!-- Toolbar -->

                <!-- <div class="ecb-course-calendar-toolbar">

                    <button type="button" class="btn ecb-course-calendar-today-button" (click)="goToToday()">

                        Today

                    </button>


                    <button type="button" class="btn ecb-course-calendar-navigation-button" (click)="goToPrevious()">

                        <i class="bi bi-chevron-left"></i>

                    </button>


                    <button type="button" class="btn ecb-course-calendar-navigation-button" (click)="goToNext()">

                        <i class="bi bi-chevron-right"></i>

                    </button>


                    <div class="ecb-course-calendar-view-buttons">

                        <button type="button" class="btn" [class.active]="activeCalendarView === 'dayGridMonth'"
                            (click)="changeCalendarView('dayGridMonth')">

                            Month

                        </button>


                        <button type="button" class="btn" [class.active]="activeCalendarView === 'timeGridWeek'"
                            (click)="changeCalendarView('timeGridWeek')">

                            Week

                        </button>


                        <button type="button" class="btn" [class.active]="activeCalendarView === 'timeGridDay'"
                            (click)="changeCalendarView('timeGridDay')">

                            Day

                        </button>

                    </div>


                    <button type="button" class="btn ecb-course-calendar-filter-toggle-button"
                        (click)="isFilterPanelVisible = !isFilterPanelVisible">

                        <i class="bi bi-funnel"></i>

                    </button>

                </div> -->
                <div class="ecb-course-calendar-toolbar">

                    <button type="button" class="btn ecb-course-calendar-today-button" (click)="goToToday()">

                        Today

                    </button>


                    <button type="button" class="btn ecb-course-calendar-navigation-button" (click)="goToPrevious()">

                        <i class="bi bi-chevron-left"></i>

                    </button>


                    <button type="button" class="btn ecb-course-calendar-navigation-button" (click)="goToNext()">

                        <i class="bi bi-chevron-right"></i>

                    </button>


                    <div class="ecb-course-calendar-view-buttons">

                        <button type="button" class="btn" [class.active]="activeCalendarView === 'dayGridMonth'"
                            (click)="changeCalendarView('dayGridMonth')">

                            Month

                        </button>


                        <button type="button" class="btn" [class.active]="activeCalendarView === 'dayGridWeek'"
                            (click)="changeCalendarView('dayGridWeek')">

                            Week

                        </button>


                        <button type="button" class="btn" [class.active]="activeCalendarView === 'dayGridDay'"
                            (click)="changeCalendarView('dayGridDay')">

                            Day

                        </button>

                    </div>


                    <button type="button" class="btn ecb-course-calendar-filter-toggle-button"
                        (click)="isFilterPanelVisible = !isFilterPanelVisible">

                        <i class="bi bi-funnel"></i>

                    </button>

                </div>

            </div>


            <!-- ===================================================== -->
            <!-- MAIN -->
            <!-- ===================================================== -->

            <div class="row g-4">


                <!-- Filter -->
                <div class="col-12 col-xl-3" *ngIf="isFilterPanelVisible">

                    <aside class="ecb-course-calendar-filter-panel">


                        <div class="ecb-course-calendar-filter-header">

                            <h4>
                                Filters
                            </h4>

                            <button type="button" class="btn" (click)="clearFilters()">

                                Clear All

                            </button>

                        </div>


                        <!-- Course -->
                        <div class="ecb-course-calendar-filter-section">

                            <label class="ecb-course-calendar-filter-label">
                                Course Type
                            </label>



                            <div class="ecb-course-calendar-filter-course-list">

                                <div class="ecb-course-calendar-filter-course-item"
                                    *ngFor="let filter of courseTypeFilters" (click)="toggleCourseFilter(filter)">

                                    <div class="ecb-course-calendar-filter-checkbox" [class.selected]="filter.selected">
                                        <i class="bi bi-check" *ngIf="filter.selected"></i>
                                    </div>

                                    <span class="ecb-course-calendar-filter-color"
                                        [style.backgroundColor]="filter.backgroundColor">
                                    </span>

                                    <span class="ecb-course-calendar-filter-name">
                                        {{ filter.name }}
                                    </span>

                                    <span class="ecb-course-calendar-filter-count">
                                        {{ filter.count }}
                                    </span>

                                </div>

                            </div>

                        </div>


                        <!-- Location -->
                        <div class="ecb-course-calendar-filter-section">

                            <label for="calendarLocation" class="ecb-course-calendar-filter-label">

                                Location

                            </label>


                            <select id="calendarLocation" class="form-select ecb-course-calendar-location-select"
                                [(ngModel)]="selectedLocation" name="calendarLocation">

                                <option value="">
                                    All Locations
                                </option>

                                <option *ngFor="let location of availableLocations" [value]="location">

                                    {{ location }}

                                </option>

                            </select>

                        </div>


                        <button type="button" class="btn ecb-course-calendar-apply-button" (click)="applyFilters()">

                            Apply Filters

                        </button>

                    </aside>

                </div>


                <!-- Calendar -->
                <div [ngClass]="
            isFilterPanelVisible
              ? 'col-12 col-xl-9'
              : 'col-12'
          ">

                    <div class="ecb-course-calendar-wrapper">

                        <div class="ecb-course-calendar-month-title">

                            <h2>
                                {{ calendarTitle }}
                            </h2>

                        </div>


                        <div class="ecb-course-calendar-loading" *ngIf="isCalendarLoading">

                            <div class="spinner-border" role="status">
                            </div>

                        </div>


                        <full-calendar #courseCalendar [options]="calendarOptions">
                        </full-calendar>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>



<!-- ========================================================= -->
<!-- COURSE DETAILS MODAL -->
<!-- ========================================================= -->

<div class="ecb-course-details-modal-backdrop" *ngIf="showCourseModal" (click)="closeCourseDetails()">

    <div class="ecb-course-details-modal ecb-course-booking-modal" (click)="$event.stopPropagation()">


        <!-- Header -->
        <div class="ecb-course-booking-header">

            <div>

                <h2>

                    {{ selectedCourseDetails?.courseCode }}

                    <span *ngIf="selectedCourseDetails?.courseCode">-</span>

                    {{ selectedCourseDetails?.courseName }}

                </h2>


                <span class="ecb-course-booking-type-badge">

                    Training Course

                </span>

            </div>


            <!-- Keep the primary enquiry / booking action fixed beside the course title. -->
            <div class="ecb-course-booking-header-actions">

                <!-- Main action stays visible while only the modal content area scrolls. -->
                <button *ngIf="this.selectedCourseDetails?.totalAmount ==0" type="button"
                    class="btn ecb-course-booking-main-button ecb-course-booking-header-button"
                    [disabled]="selectedCourseDetails?.availableSeats <= 0" (click)="openParticipantDetails()">

                    <span>
                        {{ primaryActionText }}
                    </span>

                    <i class="bi bi-arrow-right"></i>

                </button>

                <!-- Main action stays visible while only the modal content area scrolls. -->
                <button *ngIf="this.selectedCourseDetails?.totalAmount >0" type="button"
                    class="btn ecb-course-booking-main-button ecb-course-booking-header-button"
                    [disabled]="selectedCourseDetails?.availableSeats <= 0"   (click)="showingOccurrencePicker = true">
                    <i class="bi bi-cart-plus me-2"></i> Add to Cart

                </button>

                <!-- Close the course details popup. -->
                <button type="button" class="ecb-course-details-close-button" (click)="closeCourseDetails()">

                    <i class="bi bi-x-lg"></i>

                </button>

            </div>

        </div>


        <!-- Scroll only the course content while the title and action stay fixed. -->
        <div class="ecb-course-booking-scroll-content">


            <!-- Description -->
            <div class="ecb-x-details-rte-content   " *ngIf="selectedCourseDetails?.description"
                [innerHTML]="selectedCourseDetails?.description | normalizeRteSpacing | safeHtml">
            </div>

            <!-- Information Strip -->
            <div class="ecb-course-booking-information-strip">


                <div class="ecb-course-booking-strip-item">

                    <div class="ecb-course-booking-strip-icon">

                        <i class="bi bi-calendar-check"></i>

                    </div>


                    <div>

                        <small>
                            ASSESSMENT
                        </small>

                        <strong>
                            Practical and Knowledge Assessment
                        </strong>

                    </div>

                </div>


                <div class="ecb-course-booking-strip-divider">
                </div>


                <div class="ecb-course-booking-strip-item">

                    <div class="ecb-course-booking-strip-icon">

                        <i class="bi bi-clock"></i>

                    </div>


                    <div>

                        <small>
                            COURSE DATES
                        </small>

                        <strong>

                            {{
                            selectedCourseDetails?.registrationStartDate
                            | date:'dd MMM yyyy'
                            }}

                            -

                            {{
                            selectedCourseDetails?.registrationEndDate
                            | date:'dd MMM yyyy'
                            }}

                        </strong>

                    </div>

                </div>

            </div>


            <!-- Main Body -->
            <div class="row g-4 ecb-course-booking-content">


                <!-- LEFT -->
                <div class="col-12 col-lg-6">


                    <div class="ecb-course-booking-detail-row">

                        <span>
                            Registrations Close
                        </span>

                        <strong>

                            {{
                            selectedCourseDetails?.registrationStartDate
                            | date:'dd MMM yyyy'
                            }}

                        </strong>

                    </div>


                    <div class="ecb-course-booking-detail-row">

                        <span>
                            Course Dates
                        </span>

                        <strong>

                            {{
                            selectedCourseDetails?.registrationStartDate
                            | date:'dd MMM yyyy'
                            }}

                            to

                            {{
                            selectedCourseDetails?.registrationEndDate
                            | date:'dd MMM yyyy'
                            }}

                        </strong>

                    </div>


                    <div class="ecb-course-booking-detail-row">

                        <span>
                            Vacancies
                        </span>

                        <strong class="ecb-course-booking-vacancies">

                            {{ selectedCourseDetails?.availableSeats }}

                            Seats Available

                        </strong>

                    </div>


                    <div class="ecb-course-booking-detail-row">

                        <span>
                            Location
                        </span>

                        <strong class="ecb-course-booking-location">

                            <i class="bi bi-geo-alt"></i>

                            {{ selectedCourseDetails?.location }}

                        </strong>

                    </div>


                    <!-- Selection -->
                    <div class="ecb-course-booking-selection-box">

                        <h5>

                            <i class="bi bi-clipboard2-check"></i>

                            Your Selection

                        </h5>


                        <div class="ecb-course-booking-selection-row">

                            <span>
                                Primary Course
                            </span>

                            <strong>

                                {{ selectedCourseDetails?.courseCode }}

                                <span *ngIf="selectedCourseDetails?.courseCode">-</span>

                                {{ selectedCourseDetails?.courseName }}

                            </strong>

                        </div>


                        <div class="ecb-course-booking-selection-row" *ngIf="selectedAdditionalUOCs.length > 0">

                            <span>

                                UOC Courses
                                ({{ selectedAdditionalUOCs.length }})

                            </span>

                            <strong>

                                <ng-container *ngFor="
                  let course of selectedAdditionalUOCs;
                  let last = last
                ">

                                    {{ course.courseCode }}

                                    <span *ngIf="!last">
                                        ,
                                    </span>

                                </ng-container>

                            </strong>

                        </div>


                        <div class="ecb-course-booking-selection-row" *ngIf="selectedAdditionalVOCs.length > 0">

                            <span>

                                VOC Courses
                                ({{ selectedAdditionalVOCs.length }})

                            </span>

                            <strong>

                                <ng-container *ngFor="
                  let voc of selectedAdditionalVOCs;
                  let last = last
                ">

                                    {{ voc.vocCode }}

                                    <span *ngIf="!last">
                                        ,
                                    </span>

                                </ng-container>

                            </strong>

                        </div>


                        <div class="ecb-course-booking-selection-total">

                            <div>

                                <i class="bi bi-collection"></i>

                                <span>
                                    Total Courses
                                </span>

                                <strong>
                                    {{ totalSelectedCourses }}
                                </strong>

                            </div>

                        </div>

                    </div>

                </div>


                <!-- RIGHT -->
                <div class="col-12 col-lg-6">


                    <!-- UOC -->
                    <div class="ecb-course-booking-add-box">

                        <h4>

                            Add UOC Course(s)


                        </h4>


                        <p>
                            Select one or more UOC courses to book
                            along with this course.
                        </p>


                        <select class="form-select custom-select" [(ngModel)]="selectedUOCId" name="selectedUOCId"
                            (change)="addSelectedUOC()">

                            <option [ngValue]="null">
                                Select UOC Course
                            </option>

                            <option *ngFor="let course of availableUOCCourses" [ngValue]="course.id">

                                <!-- {{ course.courseCode }} - {{ course.courseTitle }} -->
                                {{ course.courseTitle }}

                            </option>

                        </select>


                        <div class="ecb-course-booking-added-item" *ngFor="let course of selectedAdditionalUOCs">

                            <div>

                                <i class="bi bi-check-square-fill"></i>

                                <span>

                                    <!-- <strong>
                                        {{ course.courseCode }}
                                    </strong> -->

                                    <!-- - -->

                                    {{ course.courseTitle }}

                                    <!-- Calendar selected course indicator -->
                                    <small *ngIf="course.isPrimaryCalendarCourse" class="ms-2 text-muted">

                                        Selected from calendar

                                    </small>

                                </span>

                            </div>


                            <!-- Only additional manually selected UOCs can be removed -->
                            <button *ngIf="!course.isPrimaryCalendarCourse" type="button"
                                (click)="removeSelectedUOC(course.id)">

                                <i class="bi bi-x"></i>

                            </button>

                        </div>

                    </div>


                    <!-- VOC -->
                    <div class="ecb-course-booking-add-box">

                        <h4>

                            Add VOC Course(s)

                            <small>
                                (Optional)
                            </small>

                        </h4>


                        <p>
                            Select one or more VOC courses to book
                            along with this course.
                        </p>

                        <!-- [disabled]="
    isNotHighRiskCourse &&
    selectedAdditionalVOCs.length >= 1
  " -->

                        <select class="form-select" [(ngModel)]="selectedVOCId" name="selectedVOCId"
                            (change)="addSelectedVOC()">

                            <option [ngValue]="null">
                                Select VOC Course(s)
                            </option>

                            <option *ngFor="let voc of availableVOCCourses" [ngValue]="voc.id">

                                {{ voc.vocCode }} - {{ voc.vocName }}

                            </option>

                        </select>


                        <div class="ecb-course-booking-added-item" *ngFor="let voc of selectedAdditionalVOCs">

                            <div>

                                <i class="bi bi-check-square-fill"></i>

                                <span>

                                    <strong>
                                        {{ voc.vocCode }}
                                    </strong>

                                    -

                                    {{ voc.vocName }}

                                </span>

                            </div>


                            <button type="button" (click)="removeSelectedVOC(voc.id)">

                                <i class="bi bi-x"></i>

                            </button>

                        </div>

                    </div>

                </div>

            </div>


            <!-- Footer -->
            <div class="ecb-course-booking-footer">

                <div class="ecb-course-booking-total">
                    <div *ngIf="selectedCourseDetails?.totalAmount > 0 && !hasAdditionalCourses">
                        <span>
                            Total
                            <small>(GST Inclusive)</small>
                        </span>

                        <strong>
                            A${{
                            selectedCourseDetails?.totalAmount
                            | number:'1.2-2'
                            }}
                        </strong>
                    </div>

                    <div *ngIf="selectedCourseDetails?.totalAmount <= 0 || hasAdditionalCourses">
                        <span>
                            Please contact 1300 322 488
                        </span>
                    </div>

                </div>


            </div>

        </div>
        <!-- End scrollable course content. -->

    </div>

</div>



<!-- ========================================================= -->
<!-- PARTICIPANT DETAILS MODAL -->
<!-- ========================================================= -->

<div class="ecb-participant-modal-backdrop" *ngIf="showParticipantModal">

    <div class="ecb-participant-modal">


        <!-- Header -->
        <div class="ecb-participant-modal-header">

            <div>

                <h3>
                    Participant Details
                </h3>

                <p>

                    Enter the participant details before

                    <ng-container *ngIf="!hasAdditionalCourses">
                        proceeding with the payment.
                    </ng-container>

                    <ng-container *ngIf="hasAdditionalCourses">
                        sending your booking enquiry.
                    </ng-container>

                </p>

            </div>


            <button type="button" class="btn ecb-participant-back-button" (click)="backToCourseDetails()">

                <i class="bi bi-arrow-left"></i>

                Back

            </button>

        </div>


        <!-- Form -->
        <div class="ecb-participant-form">


            <div class="ecb-participant-form-row">

                <label for="participantGivenName">

                    Given Name:
                    <span>*</span>

                </label>


                <input id="participantGivenName" type="text" class="form-control" [maxlength]="250"
                    [(ngModel)]="participantGivenName" name="participantGivenName">

            </div>


            <div class="ecb-participant-form-row">

                <label for="participantFamilyName">

                    Family:

                </label>


                <input id="participantFamilyName" type="text" class="form-control" [maxlength]="250"
                    [(ngModel)]="participantFamilyName" name="participantFamilyName">

            </div>


            <div class="ecb-participant-form-row">

                <label for="participantEmail">
                    Emails:
                    <span>*</span>
                </label>

                <input id="participantEmail" type="email" class="form-control" maxlength="250"
                    [(ngModel)]="participantEmail" name="participantEmail" #participantEmailCtrl="ngModel"
                    appEmailValidator required>



            </div>

            <div class="ecb-participant-form-row">

                <label for="participantPhone">
                    Contact Number:
                    <span>*</span>
                </label>

                <input id="participantPhone" type="text" class="form-control" [(ngModel)]="participantPhone"
                    name="participantPhone" #participantPhoneCtrl="ngModel" required appPhoneNumberValidation>

            </div>

        </div>


        <!-- Summary -->
        <div class="ecb-participant-summary">


            <div class="ecb-participant-summary-row">

                <span>
                    Course
                </span>

                <strong>

                    {{ selectedCourseDetails?.courseCode }}

                    -

                    {{ selectedCourseDetails?.courseName }}

                </strong>

            </div>


            <div class="ecb-participant-summary-row" *ngIf="selectedAdditionalUOCs.length > 0">

                <span>
                    Additional UOC
                </span>

                <strong>

                    {{ selectedAdditionalUOCs.length }}

                </strong>

            </div>


            <div class="ecb-participant-summary-row" *ngIf="selectedAdditionalVOCs.length > 0">

                <span>
                    VOC Courses
                </span>

                <strong>

                    {{ selectedAdditionalVOCs.length }}

                </strong>

            </div>


            <div class="ecb-participant-summary-row ecb-participant-summary-total" *ngIf="!hasAdditionalCourses">

                <span>
                    Total Payment
                </span>

                <strong>

                    A${{
                    selectedCourseDetails?.totalAmount
                    | number:'1.2-2'
                    }}

                </strong>

            </div>


            <div class="ecb-participant-summary-row ecb-participant-summary-total" *ngIf="hasAdditionalCourses">

                <span>
                    Booking Type
                </span>

                <strong>
                    Course Enquiry
                </strong>

            </div>

        </div>


        <!-- Error -->
        <div class="alert alert-danger mt-3" *ngIf="participantFormError">

            {{ participantFormError }}

        </div>

        <div class="alert alert-danger mt-3" *ngIf="participantEmailCtrl.invalid &&
               (participantEmailCtrl.dirty || participantEmailCtrl.touched)">

            <span *ngIf="participantEmailCtrl.errors?.['required']">
                Email is required.
            </span>

            <span *ngIf="participantEmailCtrl.errors?.['invalidEmail']">
                Please enter a valid email address.
            </span>

        </div>


        <!-- Footer -->
        <div class="ecb-participant-modal-footer">

            <button type="button" class="btn ecb-participant-cancel-button" (click)="closeParticipantModal()">

                Cancel

            </button>


            <button type="button" class="btn" [ngClass]="
    hasAdditionalCourses || selectedCourseDetails?.totalAmount <= 0
      ? 'ecb-participant-enquiry-button'
      : 'ecb-participant-pay-button'
  " [disabled]="isSubmittingParticipant" (click)="submitParticipantDetails()">

                <i class="bi" [ngClass]="
      hasAdditionalCourses || selectedCourseDetails?.totalAmount <= 0
        ? 'bi-send'
        : 'bi-lock-fill'
    ">
                </i>

                <span *ngIf="!isSubmittingParticipant">
                    {{ participantActionText }}
                </span>

                <span *ngIf="isSubmittingParticipant">
                    Processing...
                </span>

            </button>

        </div>

    </div>

</div>
<!-- End Participant Details Modal -->

<div class="calendar-update-message" *ngIf="showDataUpdatedMessage">

    Latest course data has been retrieved.

</div>


<p-dialog [(visible)]="showEnquirySuccessPopup" [modal]="true" [closable]="false" [draggable]="false"
    [resizable]="false" [style]="{ width: '460px' }">

    <div class="text-center p-3">

        <i class="bi bi-check-circle-fill" style="
        font-size: 52px;
        color: #e35d1a;
      ">
        </i>

        <h3 style="
        margin-top: 18px;
        color: #56302b;
      ">
            Thank you for your enquiry!
        </h3>

        <p style="
        margin-top: 12px;
        color: #555;
        line-height: 1.6;
      ">

            Your course has been sent,

            <br><br>

            returned to our homepage.

        </p>

        <button type="button" class="btn ecb-x-corporate-save-button mt-3" (click)="closeEnquirySuccessPopup()">

            OK

        </button>

    </div>

</p-dialog>

<!-- =========================================================
     End Short Course Details
========================================================= -->
<app-occurrence-picker *ngIf="showingOccurrencePicker" kind="SHORT" [courseId]="selectedCourseId" (closed)="showingOccurrencePicker=false"></app-occurrence-picker>